  
<template>
  <v-card
    v-if="!loadingFetch"
    flat
    color="transparent"
    outlined
    class="pa-4"
  >
    <!-- Título + Acciones -->
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6">
        <h2 class="font-weight-bold mb-2">Historial</h2>
      
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>
    <v-row
        align="start"
        justify="center"
        class="mt-2 mx-auto"
        v-if="historialPreciosProducto.length > 0"
      >
        <v-col cols="8">
          <v-timeline align-top :reverse="true" >
            <v-timeline-item
              v-for="precio in historialPreciosProducto"
              :key="precio.id"
              color="pink"
              small
            >
            <span slot="opposite">
              
              <v-list-item>
                <v-list-item-content>

                  <v-list-item-title>
                  {{ moment(precio.fecha_actualizacion).format("lll") }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ precio.usuario }}
                </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
              </span>
              <v-hover v-slot="{ hover }" close-delay="100">
                    <v-card
                      :color="hover ? '#E91E62' : ''"
                      :elevation="hover ? 16 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-container>
                        <v-list-item class="grow">
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              <span style="font-size: 20px"
                                ><strong>{{
                                  precio.precio_venta | convertPesoArg()
                                }}</strong></span
                              >
                            </v-list-item-subtitle>
                            <v-list-item-title>
                              <div class="text-caption mb-2">Precio venta</div>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        
                        <v-list-item>
                          <v-row>
                            <v-col cols="6">
                              <strong>{{
                                precio.precio_costo | convertPesoArg()
                              }}</strong>
                              <div class="text-caption mb-2">Precio Costo</div>
                            </v-col>
                            <v-col cols="6">
                              <strong>{{
                                precio.iva_compra
                              }}%</strong>
                              <div class="text-caption mb-2">IVA compra</div>
                            </v-col>
                            <v-col cols="6">
                              <strong>{{ precio.iva }}%</strong>
                              <div class="text-caption mb-2">IVA Venta</div>
                            </v-col>
                            <v-col cols="6">
                              <strong>{{ precio.ganancia }}%</strong>
                              <div class="text-caption mb-2">Ganancia</div>
                            </v-col>
                            
                          
                          </v-row>
                        </v-list-item>
                      </v-container>
                    </v-card>
              </v-hover>
      
            </v-timeline-item>
            <v-timeline-item v-if="next_page" class="mb-4" hide-dot>
              <v-btn @click="fetchNextPage()" class="mx-0"> Más </v-btn>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
  </v-card>
</template>
    
  <script>
import { mapState } from "vuex";
import ProductosAPI from "@/api/productos";

export default {
  name: "SucursalProductoInventario",
  $_veeValidate: {
    validator: "new",
  },
  props: {
    productoProp: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadingFetch: false,
      productoSucursal: null,
      historialPreciosProducto:  [],
      paginacion: { page: 1, cantidad: 0, rowsPerPage: 12 },
      next_page: false,
    };
  },

  methods: {
    fetchNextPage() {
      this.paginacion.page = this.paginacion.page + 1;
      this.fetchHistorialProducto(this.producto.id);
    },
    fetchHistorialProducto(id) {
      this.loadingFetch = true;
      ProductosAPI.indexHistorial(id, this.paginacion).then((response) => {
        console.log(response.data.next);
        if (response.data.next) {
          console.log("si");
          this.next_page = true;
        } else {
          this.next_page = false;
        }
        if (this.historialPreciosProducto.length > 0) {
          this.historialPreciosProducto = this.historialPreciosProducto.concat(
            response.data.results
          );
        } else {
          this.historialPreciosProducto = response.data.results;
          console.log(this.historialPreciosProducto );
          
        }

        this.loadingFetch = false;
      }).catch(e => {
        console.log(e);
        
        this.loadingFetch = false;

      })
    },
  },
  watch: {
    productoProp: {
      handler(newVal) {
        this.fetchHistorialProducto(newVal.id);
      },
      immediate: true, // Ejecuta el watcher inmediatamente al montar
      // deep: true // Opcional: Si la prop es reactiva en el padre y cambia internamente sin ser un objeto nuevo
    },
  },
};
</script>
    
  <style scoped>
.items3:hover ::-webkit-scrollbar {
  width: 8px !important;
  padding: 0px;
}

.items3 ::-webkit-scrollbar {
  width: 0px;
  height: 18px;
}

.items3 ::-webkit-scrollbar-track {
  background: transparent;
  padding: 0px;
}

.items3 ::-webkit-scrollbar-thumb {
  background: #888;
}
</style>
    